import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-[#FBF6EF]" data-id="element-140" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-141" data-mp="223ek9hugb31v">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border border-slate-200 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg shadow-[#1F4D3A]/5" data-id="element-142" data-mp="2223j7pse49eg">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-[#1F4D3A] border-2 border-[#C9A24B] text-white mb-8" data-id="element-143" data-mp="1j52e84yu69ai">
            <ShieldCheck size={48} data-id="element-144" data-mp="1ecj096w8lc56" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-6 text-[#1F4D3A] uppercase" data-id="element-145" data-mp="qnq2d4w20u7x">
            <span className="text-[#9C7726]" data-id="element-146" data-mp="lpy8w6frh01m">7-Day</span> Guarantee
          </h2>
          <div className="space-y-6 text-lg text-slate-700 max-w-2xl mx-auto" data-id="element-147" data-mp="ozrnm9o7kbza">
            <p data-id="element-148" data-mp="oxozjv6m8sx7">
              Your purchase includes a 7-day guarantee for materials that are not delivered or are
              delivered incorrectly.
            </p>
            <p className="font-medium text-[#1F4D3A]" data-id="element-149" data-mp="ypur53syh8bv">
              If you experience an eligible issue, contact our support team within the guarantee
              period so we can review your case and resolve the problem according to the applicable
              guarantee terms.
            </p>
            <p className="text-sm text-slate-500 mt-8" data-id="element-150" data-mp="b0a68fd8s0zy">All materials are delivered digitally.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}